import Component from '../../shared/component';

export default class TeacherUpdateOccupationModal extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
    this.showModal();
  }

  bindEvents() {
    this.handleModalShow = this.handleModalShow.bind(this);

    this.$element.on(
      'show.bs.modal.teacherUpdateOccupationModal',
      this.handleModalShow
    );
  }

  unbindEvents() {
    this.$element.off(
      'show.bs.modal.teacherUpdateOccupationModal',
      this.handleModalShow
    );
  }

  showModal() {
    this.$element.modal('show');
  }

  markModalAsRead() {
    $.ajax({
      url: this.$element.data('read-url'),
      type: 'PUT',
      // eslint-disable-next-line camelcase
      data: {user: {teacher_update_occupation_modal_read_at: new Date()}},
      dataType: 'json',
    });
  }

  handleModalShow() {
    this.markModalAsRead();
  }
}
